import { render, staticRenderFns } from "./diaAlfakodo.vue?vue&type=template&id=b9b62b28"
import script from "./diaAlfakodo.vue?vue&type=script&lang=js"
export * from "./diaAlfakodo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports